/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Grow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Grow"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#4BA279"
        d="M12 2c1.042 0 2.083 2.5 2.083 6.667l-.003.146C17.53 7.2 22 7.702 22 8.667c0 .833-2.379 1.06-5.01 2.378-.948.475-1.898 1.124-2.846 1.596 2.175.996 3.264 2.86 2.715 3.419-.599.608-2.626-1.581-4.026-1.622v2.598c3.316.282 6.127 2.233 7.5 4.964A26.4 26.4 0 0 0 12 20.672c-2.946 0-5.759.472-8.333 1.328 1.373-2.731 4.184-4.682 7.5-4.964v-2.599c-1.4.042-3.427 2.23-4.026 1.623-.549-.559.54-2.423 2.714-3.42-.948-.47-1.897-1.12-2.845-1.595C4.379 9.727 2 9.5 2 8.667c0-.965 4.47-1.466 7.919.146l-.002-.146C9.917 4.5 10.958 2 12 2"
        className="Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M11.207 14.436h-.04v2.6c-3.316.282-6.127 2.233-7.5 4.964A26.4 26.4 0 0 1 12 20.672c2.946 0 5.76.472 8.333 1.328-1.372-2.731-4.184-4.682-7.5-4.965v-2.598l-.04-.001c-.323 0-.583-.054-.793-.154-.21.1-.47.154-.793.154"
        className="Details"
      />
    </g>
  </svg>
);

export const GrowIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'grow-icon'}
      icon={Grow}
      {...props}
      size={size}
    />
  );
};
